/**
 * ? @description : Main Component
 */

// Dependencies
import React from "react";

// CSS Component
import "../App.css";

// Components
import Title from "./title/Title";
import StudentModule from "./student-module/StudentModule";


const MainPage = () => {
  return (
    <div className="container-fluid p-0 overflow-hidden">
    <Title />
    <StudentModule />
  </div>
  )
}

export default MainPage

